import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import StartWrapSequencerNode from "models/audioEditor/sequencerNodes/StartWrapSequencerNode";
import EndMuteWrapSequencerNode from "models/audioEditor/sequencerNodes/EndMuteWrapSequencerNode";
import AudioFilterFactory from "models/audioEditor/filters/AudioFilterFactory";

const CLASSNAME = "StartMuteWrapSequencerNode";
const BUILT_IN_AUDIO_FILTERS_NAMES = { MUTE: "mute" };

const StartMuteWrapSequencerNode = StartWrapSequencerNode.extend({
    idAttribute: "id",

    constructor: function(attributes, options, createdFromClone, objBeingCloned, sequencerNodeCidToCloneNodeMap) {
        StartWrapSequencerNode.apply(this, [attributes, options, createdFromClone, objBeingCloned, sequencerNodeCidToCloneNodeMap]);
        if (attributes && attributes.audioSegment) {
            this._initBuiltInDefaultFilters();
        }
    },

    _initBuiltInDefaultFilters: function(){
        const muteGainFilter = AudioFilterFactory.getInstance().createGainFilter(0);
        muteGainFilter.setName(BUILT_IN_AUDIO_FILTERS_NAMES.MUTE);
        this.addBuiltInAudioFilter(muteGainFilter.getName(), muteGainFilter);
    },

    getConstructor: function(){
        return StartMuteWrapSequencerNode;
    },

    cloneJSON: function(){
        const objJson = StartWrapSequencerNode.prototype.cloneJSON.call(this);
        objJson.type = StartMuteWrapSequencerNode.CLASSNAME;
        objJson.targetTrackId = this.get("targetTrackId") || null;
        return objJson;
    },

    getSerializedData: function(){
        return StartWrapSequencerNode.prototype.getSerializedData.call(this);
    },

    restoreFromSerializedData: function(serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray){
        return StartWrapSequencerNode.prototype.restoreFromSerializedData.call(this, serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray);
    },

    afterAllInstancesCreatedFromSerializedData: function(serializedData, sequencerNodeCidToSequencerNodeMap){
        StartWrapSequencerNode.prototype.afterAllInstancesCreatedFromSerializedData.call(this, serializedData, sequencerNodeCidToSequencerNodeMap);
    },

    createEndWrapSequencerNode: function(attributes, options, createdFromClone, objBeingCloned, sequencerNodeCidToCloneNodeMap){
        if(createdFromClone && objBeingCloned && sequencerNodeCidToCloneNodeMap && objBeingCloned.getEndWrapSequencerNode() && objBeingCloned.getEndWrapSequencerNode().cid && sequencerNodeCidToCloneNodeMap[objBeingCloned.getEndWrapSequencerNode().cid]){
            return sequencerNodeCidToCloneNodeMap[objBeingCloned.getEndWrapSequencerNode().cid];
        }
        return new EndMuteWrapSequencerNode(attributes, options);
    },

    isModifyingAudioBufferFromWrappedNodeAudioSegment: function(){
        return true;
    },

    getAudioFilters: function(){
        let audioFilters = StartWrapSequencerNode.prototype.getAudioFilters.call(this);
        if (!audioFilters || audioFilters.length === 0) {
            // Edge case: constructor's _initBuiltInDefaultFilters runs only when an audioSegment
            // is provided up-front. If the node was created without one (legacy path), the built-in
            // mute filter map is empty here. Register the filter properly so it's retrievable
            // later via getBuiltInAudioFilterByName(MUTE), instead of returning a transient instance.
            this._initBuiltInDefaultFilters();
            audioFilters = StartWrapSequencerNode.prototype.getAudioFilters.call(this);
        }
        return audioFilters;
    },

    isCreatingAudioSegmentThatWillBeMergeWithWrappedNodeAudioSegment: function(){
        return false;
    },

    setTargetTrackId: function(targetTrackId){
        this.set("targetTrackId", targetTrackId || null);
        if (this.getEndWrapSequencerNode()) {
            this.getEndWrapSequencerNode().set("targetTrackId", targetTrackId || null);
        }
    },

    getTargetTrackId: function(){
        return this.get("targetTrackId") || null;
    },

    getContent: function(){
        return `<span style="display: inline-flex;align-items: center;"><span class="icon pe-7s-mute mute_icon"></span><span class="icon soundwave-drag-indicator drag_icon" style="font-size: 70%"></span></span>`;
    }
});

StartMuteWrapSequencerNode.CLASSNAME = CLASSNAME;

export default StartMuteWrapSequencerNode;
